import {
  Cell,
  Pie,
  PieChart,
  PieLabelRenderProps,
  ResponsiveContainer,
} from "recharts";

// #region Sample data
const data = [{ name: "Group A", value: 400 }];

// #endregion
const RADIAN = Math.PI / 180;
const COLORS = ["#1DBF73"];

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  if (cx == null || cy == null || innerRadius == null || outerRadius == null) {
    return null;
  }
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const ncx = Number(cx);
  const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
  const ncy = Number(cy);
  const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > ncx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${((percent ?? 1) * 100).toFixed(0)}%`}
    </text>
  );
};

export default function PieChartWithCustomizedLabel({
  isAnimationActive = true,
  statsWidget,
}) {
  return (
    <div className="card rounded-4">
      <div className="card-body">
        <h6 className="mb-3">تفصيل طريقة الدفع</h6>
        <PieChart
          style={{ width: "100%", height: "40vh", aspectRatio: 1 }}
          responsive
        >
          <Pie
            data={statsWidget?.charts?.payment_methods}
            labelLine={false}
            label={renderCustomizedLabel}
            fill="#8884d8"
            dataKey="count"
            nameKey="method"
            isAnimationActive={isAnimationActive}
          >
            {statsWidget?.charts?.payment_methods.map((entry, index) => (
              <Cell
                key={`cell-${entry.method}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            marginTop: "20px",
            gap: "15px",
          }}
        >
          {statsWidget?.charts?.payment_methods.map((entry, index) => (
            <div
              key={entry.method}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <div
                style={{
                  width: "15px",
                  height: "15px",
                  backgroundColor: COLORS[index % COLORS.length],
                }}
              ></div>
              <span>
                {entry.method} ({entry.count})
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
